module.exports = __webpack_public_path__ + "img/Children-in-Care.d5aacbe0.jpg";